import React from 'react';

import {
  HeroFrame,
  PlayerButton
} from '../HelperComponents/StyledComponents';

export const SongTableHeader = () => (
  <thead>
    <tr className="is-hidden-mobile">
      <th className="has-text-white">
        <PlayerButton className="icon-play" onClick={this.dispatchSongToPlayer} theme={{ fontSize: '20px' }} style={{ cursor: 'pointer', visibility: 'hidden' }}></PlayerButton>
      </th>
      <th className="has-text-white">Title</th>
      <th className="has-text-white">Album</th>
      <th className="has-text-white is-hidden-mobile">Style</th>
      <th className="has-text-white is-hidden-mobile">Tempo</th>
      <th className="has-text-white"></th>
    </tr>
  </thead>
);

export const BulmaSection = (props) => (
  <section className="section" style={{ padding: props.sectionPadding }}>
    <section className="container">
      <section className={`columns ${props.columnsClassName}`}>
        {props.children}
      </section>
    </section>
  </section>
);

export const BulmaHero = (props) => (
  <HeroFrame className={`hero is-bold ${props.heroSize ? props.heroSize : ''}`} theme={{ backgroundImage: props.image, backgroundColor: props.backgroundColor }}>
    <section className="hero-head">
      {props.head}
    </section>
    <section className={`${ props.activateBodyPadding ? 'hero-body' : '' }`}>
      {props.body}
    </section>
    <section className="hero-foot" style={{ position: 'relative' }}>
      {props.foot}
    </section>
  </HeroFrame>
);


// WEBPACK FOOTER //
// ./src/components/HelperComponents/HelperComponents.js